export const environment = {
    //dev
//    googleClientId: "830765184232-fac83dth0bbp2tch7ebq10drs4qfj1as.apps.googleusercontent.com",
   // apiUrl: "https://shared-drive-app-3ptjye7uca-og.a.run.app/"
    // apiUrl: "https://gwshareddriveqa.holcim.info/"
          
    //prod
    //  googleClientId: "125583278488-n9sljq7rpt07sr7lm0ldr97f60dknecf.apps.googleusercontent.com",
   // apiUrl: "https://shared-drive-app-4edy47c2pq-ew.a.run.app/"
      // apiUrl: "https://gwshareddrive.holcim.info/"


        //amrize dev
    googleClientId: '563828365284-u7f32u4ukmt5mf6488mnp0g4e5qdoun9.apps.googleusercontent.com',
    apiUrl: 'https://google-shared-drive-app-qa.amrize.com/',
    helpUrl:'https://docs.google.com/document/d/1uFBj_vY4oaxAitN8FwygrjNibH1JUK4c/edit#heading=h.a7xb1xnypo5s'
}

